import React from 'react';

import './Social.css';

const Social = (props) => (
  <nav className="App__social">
    <ul>
      <li>
        <a href="https://www.instagram.com/roblee_art/" className="App__social--instagram" target="_blank" rel="noopener">Instagram</a>
      </li>
      <li>
        <a href="https://twitter.com/roblee_art/" className="App__social--twitter" target="_blank" rel="noopener">Twitter</a>
      </li>
      <li>
        <a href="https://www.facebook.com/robleeart" className="App__social--facebook" target="_blank" rel="noopener">Facebook</a>
      </li>
    </ul>
  </nav>
);

Social.propTypes = {  
};

export default Social;


// WEBPACK FOOTER //
// ./src/components/Social.js